import React from 'react';


const title = (props) => (
    <h1 className='bg-info text-light text-center p-4 mt-2'>{props.children}</h1>     
)

export default title